import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const REDIRECT_DELAY_MS = 4000;

export default function OrderSuccess() {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(
    Math.ceil(REDIRECT_DELAY_MS / 1000)
  );

  useEffect(() => {
    document.title = "Order confirmed · Futura Bio Labs";

    const redirectTimer = setTimeout(() => {
      navigate("/");
    }, REDIRECT_DELAY_MS);

    const tickTimer = setInterval(() => {
      setSecondsLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => {
      clearTimeout(redirectTimer);
      clearInterval(tickTimer);
    };
  }, [navigate]);

  return (
    <div className="w-full min-h-screen bg-white flex items-center justify-center px-6">
      <div className="flex flex-col items-center text-center max-w-[420px]">
        <SealMark />

        <h1 className="text-gray-800 text-2xl md:text-3xl font-semibold mt-8 mb-3">
          Your order has been confirmed
        </h1>

        <p className="text-gray-500 text-sm">
          Taking you back home in {secondsLeft}s...
        </p>

        <button
          onClick={() => navigate("/")}
          className="mt-8 text-teal-600 hover:text-teal-700 text-sm font-semibold border border-teal-200 hover:border-teal-300 rounded-md px-5 py-2.5 transition-colors"
        >
          Go now
        </button>
      </div>
    </div>
  );
}

function SealMark() {
  return (
    <div className="relative w-20 h-20">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="40" cy="40" r="38" className="text-teal-50" fill="currentColor" />
        <circle
          cx="40"
          cy="40"
          r="30"
          className="text-teal-500"
          stroke="currentColor"
          strokeWidth="2"
          strokeDasharray="3 4"
        />
        <path
          d="M28 41l8 8 16-17"
          className="text-teal-600"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}